

import { configureStore } from '@reduxjs/toolkit';
import filterListReducer from './filterCatagoryListSlice';

const store = configureStore({
  reducer: {
    filterCatagoryList: filterListReducer
  },
});

export default store;